import { animated, config, useChain, useSpringRef, useTransition } from '@react-spring/web';
import React, { useMemo } from 'react';
import { useIsMounted } from '../../utils/useIsMounted/index.js';
import { Toast } from './Toast.js';
import { useToastState } from './ToastContext.js';
import { ToastProgress } from './ToastProgress.js';
import { useToast } from './useToast/index.js';
export function Toasts() {
    const { state: { toasts } } = useToastState();
    const { remove } = useToast();
    const refMap = useMemo(() => new Map(), []);
    const isMountedRef = useIsMounted();
    const springRef = useSpringRef();
    const transitions = useTransition(toasts, {
        ref: springRef,
        from: { opacity: 0, height: 0, translateY: '-100%', life: '0%' },
        keys: (toast) => toast.id,
        enter: (toast) => 
        /* istanbul ignore next - animations are skipped in tests */
        async (next) => {
            await next({
                opacity: 1,
                height: refMap.get(toast.id).offsetHeight,
                translateY: '0%'
            });
            toast.autoDismiss &&
                (await next({
                    life: '100%',
                    config: { duration: 5000 }
                }));
        },
        leave: [{ opacity: 0, height: 0, translateY: '-100%' }],
        onRest: 
        /* istanbul ignore next - animations are skipped in tests */
        (_result, _ctrl, toast) => {
            isMountedRef.current && toast.autoDismiss && remove(toast.id);
        },
        config: { ...config.stiff, clamp: true }
    });
    useChain([springRef]);
    return (React.createElement("div", { className: "twds-max-h-full twds-overflow-auto twds-scrollbar-small dark:twds-scrollbar-track-dark dark:twds-scrollbar-thumb-dark dark:twds-scrollbar-corner-dark twds-fixed twds-top-0 twds-right-0", 
        // antD modals have a high z-index, and some of those modals depend on toasts
        style: { zIndex: 2500 }, onMouseEnter: 
        /* istanbul ignore next */
        () => springRef.pause('life'), onMouseLeave: 
        /* istanbul ignore next */
        () => springRef.resume() }, transitions(({ life, ...style }, toast) => {
        return (React.createElement(animated.div, { style: style, className: "twds-overflow-hidden twds-rounded" },
            React.createElement(Toast, { ...toast, ref: (ref) => ref && refMap.set(toast.id, ref), progress: toast.progress ?? React.createElement(ToastProgress, { life: life }), remove: () => remove(toast.id) })));
    })));
}
//# sourceMappingURL=Toasts.js.map